const cloudinaryTransform = (url, size = 0, lqip) => "https://res.cloudinary.com/ddbxmpbxi/image/fetch/" + (lqip ? `f_auto,q_1/` : "q_auto:best/" ) + (size ? `c_scale,w_${size}/` : "") + url

const LazyImg = ({
                     src,
                     height = "auto",
                     width = "auto",
                     lqip = false,
                     lqipSize = 0,
                     ...props
}) => {
    if (!src || typeof src !== 'string') return null;

    const url =
        src.startsWith("./../")
            ? src.replace("./../", "https://kpjhealth.com.my/")
            : src.startsWith("./")
                ? src.replace("./", "https://kpjhealth.com.my/")
                : src;

    // temp fix for cloudinary cloud name disabled
    return (
        <img
            className="lazyload"
            src={url}
            height={height}
            width={width}
            {...props}
        />
    )

    return (
        <img
            className="lazyload"
            {...(lqip ? {src: cloudinaryTransform(url, lqipSize, lqip)} : {})}
            data-src={cloudinaryTransform(url)}
            alt=""
            data-srcset={`${cloudinaryTransform(url, 1028)} 1028w,
                        ${cloudinaryTransform(url, 768)} 768w,
                        ${cloudinaryTransform(url, 480)} 480w,
                        ${cloudinaryTransform(url)} 1x
                        `}
            data-sizes="(max-width: 480px) 440px,
                       (max-width: 768px) 720px,
                       (max-width: 1028px) 1028px"
            height={height}
            width={width}
            {...props}
        />
    )
}

export default LazyImg
